import { Injectable } from '@angular/core';
import { Router } from '@angular/router'; 
import { InternshipListModel } from 'common/models/page-models/internship/internship-list/form-model/internship-list-form-data.model';
import { InternshipListListingModel } from 'common/models/page-models/internship/internship-list/grid-model/internship-list-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { InternshipListWidgetService } from 'common/widget/internship/internship-list-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class InternshipListGridResolver extends GridResolver<InternshipListModel, InternshipListListingModel> {
    constructor(
        protected fs: InternshipListWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}